let allIds = [];

function getAllIds(){
    if(allIds && allIds.length > 0){
        return allIds;
    }

    $(".js-stories-grid .listItem").each(
        function() {
            let id = $(this).attr('id');
            allIds.push(id);
        }
    );

    return allIds;
}

function getIdsByFilterValue(value) {
    let ids = [];
    let selector = $();

    if (value && value.trim() !== "") {
        const safeValue = $.escapeSelector(value.trim());
        selector = $(".js-stories-grid .listItem." + safeValue);
    }

    if (selector.length === 0) {
        ids = getAllIds();
    } else {
        selector.each(function () {
            let id = $(this).attr("id");
            ids.push(id);
        });
    }
    return ids;
}

function showItems(){
    let ids = getAllIds();

    $('select:not(.simple)').each(function () {
        let tmp_ids = getIdsByFilterValue($(this).val());
        let intersect = $.arrayIntersect(tmp_ids, ids);

        if(intersect.length !== 0){
            ids = intersect;
        }

        $(".js-stories-grid .listItem").hide();
        for(let i=0; i < ids.length; i++){
            $('.js-stories-grid .listItem#' + ids[i]).show();
        }
    })
    return ids;
}

function updateSelect(){
    let visibleElements = $('.js-stories-grid .listItem:visible');
    $('select:not(.simple)').each(function (){
        $(this).find("option").each(function () {
            const val = $(this).val();
            if (!val) return;
            const match = visibleElements.filter((i, element) => {
                return $(element).hasClass(val)
            })
            const isOptionActive = match.length > 0
            $(this).prop('disabled', !isOptionActive);
        })
    })
}

function generateFiltersQueryParameter(){
    let filters = [];
    let searchString = ""
    let filtersString;

    if(getQueryParameterByName("search", window.location.href)) {
        searchString = "?search=" + getQueryParameterByName("search", window.location.href) + "&"
    }

    $('select:not(.simple)').each(function(){
        if($(this) && $(this).val() !== ""){
            filters.push($(this).val());
        }
    });

    if(filters && filters.length > 0){
        filtersString = "";
        filters.forEach(function (filter) {
            filtersString += filter + ",";
        });
        filtersString = (searchString ? "" : "?") + "filters=" + filtersString.slice(0, -1);
        $('#filters_reset_link').css("display", "inline-block");
    } else {
        $('#filters_reset_link').css("display", "none");
    }

    window.history.replaceState(null, null, (searchString || "") + (filtersString || "?"));
}

function getQueryParameterByName(name, url) {
    name = name.replace(/[\[\]]/g, '\\$&');
    let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function applyFiltersFromQueryParameter(){
    let looped = false;
    let filtersQueryParameter = getQueryParameterByName("filters", window.location.href);

    if(filtersQueryParameter){
        let filtersList = filtersQueryParameter.split(",");
        if(filtersList && filtersList.length > 0){

            filtersList.forEach(function (filter) {
                $('select:not(.simple)').each(function () {
                    let $option = $(this).find('option').filter(function () {
                        return $(this).val() === filter;
                    })
                    if ($option.length) {
                        let currentVal = $(this).val() || [];
                        if (!currentVal.includes(filter)) {
                            currentVal.push(filter);
                            $(this).val(currentVal).trigger('change.select2');
                        }
                        showSelectedValue($(this))
                    }
                })
                showItems();
                updateSelect();
                looped = true;
            });
        }
        $('#filters_reset_link').css("display", "inline-block");
    }

    if(!looped){
        showItems();
        updateSelect();
    }
}

function showSelectedValue(select) {
    let filterName = (select[0].id).split("-")[1]
    let selectedText = select.find("option:selected").text();
    $("#af-"+filterName+" span").text(selectedText)
    $("#af-"+filterName).removeClass("d-none")
}

function removeActiveFilter(filterName) {
    $("#select-"+filterName).val("").trigger("change")
    $("#af-"+filterName).addClass("d-none")
    showItems();
    updateSelect()
    generateFiltersQueryParameter();
}

function setDoofinderRecipeTab() {
    setTimeout(function() {
        var $tab = $('[dfd-value-index="recipes"]');

        if ($tab.length && !$tab.hasClass('dfd-is-selected')) {
            $tab[0].click();
        }
    }, 100)
}

$(document).on('input keydown change', '.dfd-searchbox-input, input[type="search"]', function() {
    setDoofinderRecipeTab()
});

$(document).on('click', '[dfd-click="click-suggestion"]', function() {
    setDoofinderRecipeTab()
});


$(document).ready(function () {
    let selectSelector = $('select:not(.simple)')

    selectSelector.each(function () {
        $(this).find('option').each(function () {
            if($(this).val() !== ""){
                if($(".js-stories-grid .listItem." + CSS.escape($(this).val())).length === 0){
                    $(this).remove()
                }
            }
        })
    })

    selectSelector.on("select2:select", function() {
        showItems();
        showSelectedValue($(this))
        updateSelect()
        generateFiltersQueryParameter()
    })

    if(window.location.href.includes("filters=")) {
        scrollToFilter()
    }

    if(window.location.href.includes("search=")) {
        let searchParameter = getQueryParameterByName("search", window.location.href)
        $("#af-standard-recipe-input span").text(searchParameter.charAt(0).toUpperCase() + searchParameter.slice(1))
        $("#af-standard-recipe-input").css("cursor", "default").removeClass("d-none")
        $('#filters_reset_link').css("display", "inline-block");
    }

    $('#filters_reset_link').on('click', function(){
        if(getQueryParameterByName("search", window.location.href)) {
            window.location.href = $("#baseCookingUrl").text()
        }else {
            $('select:not(.simple)').each(function(){
                $(this).val("").trigger("change")
            });
            showItems();
            updateSelect()
            $('[id^="af-"]').addClass("d-none")
            generateFiltersQueryParameter();
        }
    }.bind(this));

    applyFiltersFromQueryParameter()

    let cookingSliderOptions = {
        "default" : {
            arrows: true,
            infinite: true,
            slidesToShow: 5,
            slidesToScroll: 1,
            dots: false,
            responsive: [
                {
                    breakpoint:  1200,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        centerMode: false

                    }
                },
                {
                    breakpoint:  768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerMode: true
                    }
                },
                {
                    breakpoint:  576,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerMode: true,
                        arrows: false,
                    }
                }
            ]
        }
    }
    let knowledgeSliderOptions = {
        "default": {
            arrows: false,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: false,
            variableWidth: false,
            fade: true,
            dots: true,
            appendDots: $('.appenddots')
        }
    };

    if(window.innerWidth < 1200) {
        $(".js-cooking-slider").not('.slick-initialized').slick(cookingSliderOptions["default"]);
    }else{
        if ($('.js-cooking-itemSlider').length > 5) {
            $(".js-cooking-slider").removeClass("recommended-cooking")
            $(".js-cooking-slider").not('.slick-initialized').slick(cookingSliderOptions["default"]);
        }else{
            if($(".js-cooking-slider").hasClass('.slick-initialized')){
                $(".js-cooking-slider").slick("unslick")
            }
        }
    }

    if ($('.knowledge-itemSlider').length > 1) {

        var activeClass = 'slick-active',
            ariaAttribute = 'aria-hidden';
        $(".knowledge-slider")
            .on( 'init', function() {
                $( '.slick-dots li:first-of-type' ).addClass( activeClass ).attr( ariaAttribute, false );
            } )
            .on( 'afterChange', function( event, slick, currentSlide ) {
                var $dots = $( '.slick-dots' );
                $( 'li', $dots ).removeClass( activeClass ).attr( ariaAttribute, true );
                $dots.each( function() {
                    $( 'li', $( this ) ).eq( currentSlide ).addClass( activeClass ).attr( ariaAttribute, false );
                } );
            } );

        $(".knowledge-slider").not('.slick-initialized').slick(knowledgeSliderOptions["default"]);
    }
});

function showMoreItems() {
    $(".small-listItem ").each(function () {
        $(this).removeClass("d-none")
    })
    $("#showLessButton").removeClass("d-none")
    $("#showMoreButton").addClass("d-none")
}

function showLessItems () {
    $(".small-listItem ").each(function (i) {
        if(i>2){
            $(this).addClass("d-none")
        }
    })
    $("#showLessButton").addClass("d-none")
    $("#showMoreButton").removeClass("d-none")
}

function scrollToFilter() {
    document.querySelector("#faceted-navigation-filter").scrollIntoView({behavior: 'smooth', block: 'center'});
}